import VehiclesContent from "../content/vehicleContent";
import Layout from "../layout/Layout";

const Vehicles = () => {
  return (
    <Layout>
      <VehiclesContent />
    </Layout>
  );
};

export default Vehicles;
